/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./createWebhook.defs.js";
export { main as default } from "./createWebhook.defs.js";
